import {
  Validator
} from 'vee-validate'

Validator.extend('hasNumbers', {
  getMessage: () => '1 number (0 - 9)',
  validate: (value) => {
    return /\d/.test(value)
  }
})

Validator.extend('minCharacters', {
  getMessage: () => 'at least 8 characters',
  validate: (value) => {
    return value.length >= 8
  }
})

Validator.extend('hasLowerAndUpercases', {
  getMessage: () => '1 uppercase letter & 1 lowercase letter.',
  validate: (value) => {
    return /[a-z]/.test(value) && /[A-Z]/.test(value)
  }
})

Validator.extend('specialCharacter', {
  getMessage: () => '1 special character (!@#$%^&*)',
  validate: (value) => {
    return /[!@#$%^&*)(+=._-]/.test(value)
  }
})
